import axios from 'axios'
import Qs from 'qs';
import config from '../apiConfig'
import url from '../baseUrl'

let baseUrl = url.salaryUrl;


const addFile = baseUrl + "/storage/addFile?createAccount=";
const $ajaxAddFile = params => axios.post(baseUrl + '/storage/addFile', params);

//查询任务配置列表 /workerCampaign/getPageList
const $axiosTaskConfigPageList = params => axios.get(baseUrl + '/workerCampaign/getPageList', {params});
// 添加或修改任务配置,传入id时是修改 workerCampaign/addOrUpdateCampaign
const $axiosAddOrUpdateCampaign = params => axios.post(baseUrl + '/workerCampaign/addOrUpdateCampaign', params);
// 查询任务配置关联的人 /workerCampaign/getCampaginPersonList
const $axiosGetCampaginPersonList = params => axios.get(baseUrl + '/workerCampaign/getCampaginPersonList', {params});
// 查询线索跟进人list
const $axiosGetClueHandleName = params => axios.get(baseUrl + '/workerCampaign/getClueHandleName', {params});
// 配置任务关联的人员  workerCampaign/addOrUpdateCampaignPerson
const $axiosAddOrUpdateCampaignPerson = params => axios.post(baseUrl + '/workerCampaign/addOrUpdateCampaignPerson', params);
//删除配置任务关联的人员 workerCampaign/deleteCampaignPerson
const $axiosDeleteCampaignPerson = params => axios.get(baseUrl + '/workerCampaign/deleteCampaignPerson', {params});
//查询任务配置关联的人 workerCampaign/selectByTypeCityStore
const $axiosSelectByTypeCityStore = params => axios.get(baseUrl + '/workerCampaign/selectByTypeCityStore', {params});
//查询任务列表 /workerTask/getPageList
const $axiosWorkerTaskPageList = params => axios.get(baseUrl + '/workerTask/getPageList', {params});
//查询任务详情 /workerTask/getTaskInfo
const $axiosGetTaskInfo = params => axios.get(baseUrl + '/workerTask/getTaskInfo', {params});
//创建任务(重新创建任务
const $axioCreateTask = params => axios.post(baseUrl + '/workerTask/createTask', params);
//完成或取消任务
const $axioFinishOrCancelTask = params => axios.post(baseUrl + '/workerTask/finishOrCancelTask', params);
//添加跟进记录
const $axioAddHandleLog = params => axios.post(baseUrl + '/workerTask/addHandleLog', params);
//修改任务备注
const $axioUpdateTaskContent = params => axios.post(baseUrl + '/workerTask/updateTaskContent', params);
// 分配任务或流转任务
const $axioUpdateAppointPerson = params => axios.post(baseUrl + '/workerTask/appointPerson', params);
// 线索跟进记录明细
const $axioGetClueHandleAction = params => axios.get(baseUrl + '/workerTask/getClueHandleAction', {params});

//查询面试列表  /jzworkerapiservice/workerInterview/listInterview
const $axiosListInterview = params => axios.post(baseUrl + '/workerInterview/listInterview', params);
//完成面试/jzworkerapiservice/workerInterview/finishInterview
const $axiosFinishInterview = params => axios.get(baseUrl + '/workerInterview/finishInterview', {params});
//取消面试/jzworkerapiservice/workerInterview/cancelInterview
const $axiosCancelInterview = params => axios.get(baseUrl + '/workerInterview/cancelInterview', {params});
//开始面试 /jzworkerapiservice/workerInterview/startInterview
const $axiosStartInterview = params => axios.post(baseUrl + '/workerInterview/startInterview', params);

export default {
  addFile,
  $ajaxAddFile,
  $axiosTaskConfigPageList,
  $axiosAddOrUpdateCampaign,
  $axiosGetCampaginPersonList,
  $axiosGetClueHandleName,
  $axiosAddOrUpdateCampaignPerson,
  $axiosDeleteCampaignPerson,
  $axiosSelectByTypeCityStore,
  $axiosWorkerTaskPageList,
  $axiosGetTaskInfo,
  $axioCreateTask,
  $axioFinishOrCancelTask,
  $axioAddHandleLog,
  $axioUpdateTaskContent,
  $axioUpdateAppointPerson,
  $axioGetClueHandleAction,
  $axiosListInterview,
  $axiosFinishInterview,
  $axiosCancelInterview,
  $axiosStartInterview

}
